import { AccountsScreen } from '@/components/account-view/AccountsScreen';

export function AccountsPage() {
  return <AccountsScreen />;
}
